/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */

// Import Angular

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Import FireAnt UI Components

import { Button } from './button/button';
import { ButtonGroup } from './button/button.group';
import { Icon } from './icon/icon';
import { Row } from './grid/row';
import { Col } from './grid/col';
import { Align } from './trigger/align';
import { Popup } from './trigger/popup';
import { Tooltip, TooltipTrgger } from './tooltip/tooltip';
import { Menu } from './menu/menu';
import { MenuItem } from './menu/menu.item';
import { SubMenu } from './menu/submenu';
import { MenuItemGroup } from './menu/menu.item.group';
import { Divider } from './menu/divider';
import { Dropdown } from './dropdown/dropdown';
import { DropdownButton } from './dropdown/dropdown.button';
import { Breadcrumb } from './breadcrumb/breadcrumb';
import { BreadcrumbItem } from './breadcrumb/breadcrumb.item';
import { Switch } from './switch/switch';
import { Layout, Header, Footer, Content } from './layout/layout';
import { Sider } from './layout/sider';
import { Tag } from './tag/tag';
import { CheckableTag } from './tag/checkable.tag';
import { FormControl } from './input/form.control';
import { InputBox } from './input/input';
import { InputPrefix } from './input/input.prefix';
import { InputSuffix } from './input/input.suffix';
import { InputNumber } from './input-number/input.number';
import { Search } from './input/search';
import { Addon } from './input/addon';
import { AddonBefore } from './input/addon.before';
import { AddonAfter } from './input/addon.after';
import { InputGroup } from './input/group';
import { Select } from './select/select';
import { Option } from './select/option';
import { OptionGroup } from './select/option.group';
import { NotFound } from './select/not.found';
import { Pagination } from './pagination/pagination';
import { Checkbox } from './checkbox/checkbox';
import { CheckboxGroup } from './checkbox/checkbox.group';
import { Radio } from './radio/radio';
import { RadioGroup } from './radio/radio.group';
import { Avatar } from './avatar/avatar';
import { AvatarText } from './avatar/avatar.text';
import { Badge } from './badge/badge';
import { ScrollNumber } from './badge/scroll.number';
import { FormDirective } from './form/form.directive';
import { FormItem } from './form/form.item';
import { FormLabel } from './form/form.label';
import { FormHelp } from './form/form.help';
import { Table } from './table/table';
import { TableHeader } from './table/table.header';
import { TableFooter } from './table/table.footer';
import { TableContent } from './table/table.content';
import { TableContentHeader } from './table/table.content.header';
import { TableContentBody } from './table/table.content.body';
/**
 * \@name AntModule
 * \@description 
 * AntModule is an NgModule that provides AntDesign-style TypeScript/JavaScript components.
 * @author fbchen 2017-05-15
 */
export class AntModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        FormsModule,
        BrowserAnimationsModule
    ],
    declarations: [
        Button,
        ButtonGroup,
        Icon,
        Row, Col,
        Align, Popup,
        Tooltip, TooltipTrgger,
        Menu, MenuItem, SubMenu, MenuItemGroup,
        Divider,
        Dropdown,
        DropdownButton,
        Breadcrumb, BreadcrumbItem,
        Switch,
        Layout, Header, Footer, Content, Sider,
        Tag, CheckableTag,
        FormControl,
        InputBox, InputPrefix, InputSuffix,
        InputNumber,
        Search,
        Addon, AddonAfter, AddonBefore,
        InputGroup,
        Select, Option, OptionGroup, NotFound,
        Pagination,
        Checkbox, CheckboxGroup,
        Radio, RadioGroup,
        Avatar, AvatarText,
        Badge, ScrollNumber,
        FormDirective, FormItem, FormLabel, FormHelp,
        Table, TableHeader, TableFooter,
        TableContent, TableContentBody, TableContentHeader
    ],
    exports: [
        Button,
        ButtonGroup,
        Icon,
        Row, Col,
        Tooltip, TooltipTrgger,
        Menu, MenuItem, SubMenu, MenuItemGroup,
        Divider,
        Dropdown,
        DropdownButton,
        Breadcrumb, BreadcrumbItem,
        Switch,
        Layout, Header, Footer, Content, Sider,
        Tag, CheckableTag,
        FormControl,
        InputBox, InputPrefix, InputSuffix,
        InputNumber,
        Search,
        Addon, AddonAfter, AddonBefore,
        InputGroup,
        Select, Option, OptionGroup, NotFound,
        Pagination,
        Checkbox, CheckboxGroup,
        Radio, RadioGroup,
        Avatar, AvatarText,
        Badge, ScrollNumber,
        FormDirective, FormItem, FormLabel, FormHelp,
        Table, TableHeader, TableFooter,
        TableContent, TableContentBody, TableContentHeader
    ],
    entryComponents: [
        Tooltip
    ],
    providers: [
        // Layer
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AntModule_tsickle_Closure_declarations() {
/** @type {?} */
AntModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AntModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
